/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
export default class DropZonesOverlayDOMAPI {
	/**
	 * @function DropZonesOverlayDOMAPI#getContentMenuList
	 * @description Returns the menu action items for drop zones overlay (example: show/hide overlay)
	 * @return {Object[]} list of menu action items
	 */
	getContentMenuList() { }

	/**
	 * @function DropZonesOverlayDOMAPI#render
	 * @description Renders drop zones overlay in a given container
	 */
	render() { }

	reassessDropTarget() {}

	isMounted() {}
}


// WEBPACK FOOTER //
// ./src/js/dashboard/DropZonesOverlayDOMAPI.js